import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/estado_bodega/estado_bodega';
import Despacho from './despachoNuevo';

const mstp = state => {
    return {...state.estado_bodega, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(Despacho)
